//click metrics
function trackClick(venueId,type,menuItemId){
    var uniqueKey = venueId + "_" + type;
    if (typeof(Storage) == "undefined") {
        return;
    }
    if(sessionStorage.getItem(uniqueKey)){
        //don't track multiple clicks
        return;
    }

    var e = {
        'type':type,
        'venueId':venueId,
        'menuItemId' : menuItemId,
    };
    $.ajax({
        url: "/trackrestaurant/trackClick/",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(e),
        success:function(response){
            if(response.status == "Success"){
                sessionStorage.setItem(uniqueKey,true);
            }
        }
    })
}